import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "toolbar-logs",
  "use": "toolbar-logs-usage",
  "viewBox": "0 0 20 22",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 22\" id=\"toolbar-logs\"><path d=\"M9.375 12.884h4.375M9.375 16.634h4.375M6.875 12.572a.312.312 0 110 .625.312.312 0 010-.625M9.375 9.134h4.375M6.875 8.822a.312.312 0 110 .625.312.312 0 010-.625M6.875 16.322a.312.312 0 110 .625.312.312 0 010-.625\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path clip-rule=\"evenodd\" d=\"M13.125 4.76h3.125c.69 0 1.25.559 1.25 1.25v13.124c0 .69-.56 1.25-1.25 1.25H3.75c-.69 0-1.25-.56-1.25-1.25V6.01c0-.69.56-1.25 1.25-1.25h3.125a3.125 3.125 0 016.25 0z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M10 4.134a.312.312 0 110 .625.312.312 0 010-.625\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/toolbar-logs.svg
// module id = HpOs
// module chunks = 39 44